import { useState } from "react";
import { Grid } from "semantic-ui-react";
import { images } from "../../assets/images";
import { TitleBar } from "../../components";
import BOMCard from "../../components/bomCard/BOMCard";
import { ENABLE_LCA_INGREDIENT_UI_REDESIGN } from "../../config/constants";
import { BOMViewType } from "../../config/enums/BOMViewType.enum";
import IngredientListNew from "../lcaIngredients/ingredientList/IngredientListNew";
import "./billOfMaterial.scss";
import IngredientList from "./ingredientList/IngredientList";

const BillOfMaterial = () => {
  const [activeView, setActiveView] = useState<BOMViewType>(BOMViewType.INGREDIENT);

  const handleCardClick = (view: BOMViewType) => {
    setActiveView(view);
  };

  return (
    <>
      {/* When the LCA Ingredient redesign is on, IngredientListNew renders its own
          "LCA Ingredients" heading below — showing "Bill Of Material" here as well
          would duplicate the page title, so it's suppressed in that case only. */}
      {ENABLE_LCA_INGREDIENT_UI_REDESIGN ? null : <TitleBar titleName={"Bill Of Material"} />}
      <Grid className="bill-of-material-container">
        <Grid.Column computer={16}>
          {ENABLE_LCA_INGREDIENT_UI_REDESIGN ? null : (
            <div className="bom-cards-container">
              <BOMCard
                icon={images.ingredients_icon}
                title="Add Ingredients"
                isActive={activeView === BOMViewType.INGREDIENT}
                onClick={() => handleCardClick(BOMViewType.INGREDIENT)}
              />
            </div>
          )}
          <div className={ENABLE_LCA_INGREDIENT_UI_REDESIGN ? "" : "bom-content"}>
            {(() => {
              switch (activeView) {
                case BOMViewType.INGREDIENT:
                  return ENABLE_LCA_INGREDIENT_UI_REDESIGN ? (
                    <IngredientListNew />
                  ) : (
                    <IngredientList />
                  );
                default:
                  return null;
              }
            })()}
          </div>
        </Grid.Column>
      </Grid>
    </>
  );
};

export default BillOfMaterial;
